module.exports = __webpack_public_path__ + "img/cxsq.11d985b9.png";